import { TimelineEventEntry } from "frontend/contentful/schema/primitives";
import { TimelineEventProps } from "design-system/components/primitives/timeline-event/timeline-event";
import { RenderContentfulRichText } from "../utils/render-contentful-rich-text";
import { createMediaAssetProps } from "./media-asset.props";
import { createContentfulProps } from "frontend/contentful/lib/create-contentful-props";

export const createTimelineEventProps = createContentfulProps<
  TimelineEventEntry,
  TimelineEventProps
>(({ entry, createEditAttributes }) => {
  const props: TimelineEventProps = {
    content: {
      dek: <RenderContentfulRichText document={entry.fields.description} />,
      editAttributes: {
        title: createEditAttributes({ entry, fieldId: "title" }),
        dek: createEditAttributes({ entry, fieldId: "description" }),
      },
    },
    dates: [],
    dateFormat: entry.fields.dateFormat,
    endDatePresent: entry.fields.endDatePresent,
  };

  if (entry.fields.title) {
    props.content.title = (
      <RenderContentfulRichText document={entry.fields.title} />
    );
  }

  const mediaAssetProps = createMediaAssetProps(entry.fields.media);
  if (mediaAssetProps) props.content.media = mediaAssetProps;

  if (entry.fields.startDate) {
    props.dates.push({
      date: entry.fields.startDate,
      editAttributes: {
        date: createEditAttributes({ entry, fieldId: "startDate" }),
      },
    });
  }
  if (entry.fields.endDate) {
    props.dates.push({
      date: entry.fields.endDate,
      editAttributes: {
        date: createEditAttributes({ entry, fieldId: "endDate" }),
      },
    });
  }

  return props;
});
